export default "__VITE_ASSET__CUBixnM2__"